var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"personSet_page"},[_c('div',{staticClass:"binding_content"},[_c('ul',_vm._l((_vm.binding),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.img}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.tool))]),_vm._v(" "),_c('button',[_vm._v("解除绑定")])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58790560","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/personSet/binding.vue
// module id = null
// module chunks = 